import { LOCALES } from 'state/intl/types';

export default async function polyfillPluralRules(_locale: LOCALES) {
  // noop plural rules has wide support on browsers: https://caniuse.com/?search=Plural%20Rules
}
